<template>
	<div>
		<notifications />
		<div class="row">
			<div class="col-xs-12 col-md-6">
				<section class="heading">
					<h1 class="title">Kick Off</h1>
				</section>
				<p>
					Tidak perlu bingung lagi buat kamu yang mau menghitung biaya tetap buat agency kalian.
				</p>
				<p>
					Amy sudah buat 3 langkah mudah untuk menghitung biaya tetap kamu.
				</p>
				<div class="text-center">
					<img :src="relativeUrl('/img/Rounded Rectangle 8.png')" class="img-responsive">
					<br>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<form @submit="submit">
					<div class="well well-lg">
						<h2>Langkah 1 dari 3</h2>
						<ol class="steps">
							<li class="active">01 Biaya per bulan</li>
							<li>02 Aset</li>
							<li>03 Selesai</li>
						</ol>
						<br>
						<div class="expense-categories" v-for="(category, ci) in categories" :key="ci">
							<div class="heading">
								<h3 class="expense-category">{{ category.name }}</h3>
								<add-button :onClick="() => createExpense(ci)"></add-button>
							</div>
							<div class="row expense-item" v-for="(expense, index) in category.expenses" :key="index">
								<div class="col-sm-6">
									<delete-button :onClick="() => removeExpense(ci, index)"></delete-button>
									{{ expense.name }}
								</div>
								<div class="col-sm-6">
									<money class="form-control text-right" v-model="expense.price" v-bind="money"></money>
								</div>
							</div>
							<br>
						</div>
						<hr class="primary">
						<div class="row" style="margin-bottom: 50px;">
							<div class="col-xs-6">
								<h4><b>Subtotal</b></h4>
							</div>
							<div class="col-xs-6 text-right">
								<h4><b><span v-bind="money">{{ subtotal }}</span></b></h4>
							</div>
						</div>
						<div class="text-right">
							<button type="submit" class="btn btn-primary btn-lg" :disabled="isLoading">
								<i v-show="isLoading" class="fa fa-circle-o-notch fa-spin"></i>
								Simpan
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>

		<div id="expense-modal" class="modal fade" tabindex="-1" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					<h4 class="modal-title">{{ selectedCategory.name }}</h4>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label for="expense-input">Expense</label>
						<input id="expense-input" type="text" v-model="newExpense" class="form-control">
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
					<button type="button" class="btn btn-primary" @click="storeExpense">Save</button>
				</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal-dialog -->
		</div><!-- /.modal -->
	</div>
</template>

<script>
import { relativeUrl, formatPrice, moneyTemplate } from "../../helpers";
import AddButton from "../AddButton.vue";
import DeleteButton from "../DeleteButton.vue";
import { Money } from 'v-money';

export default {
	components: {
		AddButton,
		DeleteButton,
		Money,
	},
	data() {
		return {
			categories: [],
			selectedCategoryIndex: null,
			newExpense: null,
			money: moneyTemplate(),
			expenseModal: null,
			isLoading: false,
		}
	},
	computed: {
		subtotal() {
			let val = this.categories.reduce((total, category) => {
				return total + category.expenses.reduce((subtotal, expense) => {
					return subtotal + expense.price;
				}, 0);
			}, 0);
			return formatPrice(val);
		},
		selectedCategory() {
			if (this.categories.length <= 0 || this.selectedCategoryIndex === null) {
				return { name: null, price: 0 };
			}

			return this.categories[this.selectedCategoryIndex];
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			let response = await axios.get('/fixed-expenses');
			this.categories = response.data.data;
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!',
			})
		}

		this.isLoading = false;
	},
	mounted() {
		this.expenseModal = $('#expense-modal');
	},
	methods: {
		relativeUrl,
		createExpense(categoryIndex) {
			this.selectedCategoryIndex = categoryIndex;
			this.expenseModal.modal('show');
		},
		storeExpense(e) {
			e.preventDefault();
			this.categories[this.selectedCategoryIndex].expenses.push({
				name: this.newExpense,
				price: 0,
			});
			this.selectedCategoryIndex = null;
			this.newExpense = null;
			this.expenseModal.modal('hide');
		},
		removeExpense(categoryIndex, expenseIndex) {
			this.selectedCategoryIndex = categoryIndex;
			this.categories[categoryIndex].expenses = this.selectedCategory.expenses.filter((e, i) => {
				return i != expenseIndex;
			});
		},
		async submit(e) {
			e.preventDefault();
			this.isLoading = true;

			try {
				const response = await axios.put('/fixed-expenses', {categories: this.categories});
				this.$notify({
					type: 'success',
					title: 'Expenses Saved!',
					text: 'You\'ve saved your expenses!'
				});
				this.$router.push('base-price-wizard/assets');
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!',
				})
			}

			this.isLoading= false;
		}
	}
}
</script>

<style lang="less" scoped>
.expense-categories {
	> .heading {
		margin-bottom: 10px;
		justify-content: flex-start;
		align-items: center;
	}
	.expense-category {
		margin: 0 10px 0 0;
	}
	.expense-item:not(:last-of-type) {
		padding-bottom: 10px;
	}
}
</style>
